module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9G0djV/media/FC-9781685627157.jpg?1708094026459",
      "alt": "This image is the cover for the book Medicine Park"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Medicine Park\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_c('em', [_vm._v("Medicine Park")]), _vm._v(" is a compelling small-town murder mystery that takes place in southwestern Oklahoma in the historically pivotal year of 1963.")]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v("As the town’s high-school history teacher reminds us: “People have lived here all their lives, but they have no idea what goes on beneath the surface.”")]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_c('em', [_vm._v("Medicine Park")]), _vm._v(" uniquely blends engaging characters, humor, romance, suspense, and Native American tribal culture – with a splash of metaphysics, a dash of the macabre, and an onslaught of surprising twists and turns.")]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_c('em', [_vm._v("Buckle up!")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Curry\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("After graduating from the University of Oklahoma (oh – so long ago), David bolted to Los Angeles to find something – anything – different from the red- dirt predictability of his native land. In California, he eventually found his niche – writing advertising, TV comedies, and dozens upon dozens of live corporate stage productions.")]), _c('p', [_vm._v("Decades later, David returned to his Oklahoma roots to be warmly greeted by family and long-lost friends, plus the cold reality of a pandemic...which gave him more than enough time to write.")]), _c('p', [_vm._v("Hence, came up his first novel – "), _c('em', [_vm._v("Medicine Park.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0